import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseService } from '../services/base-service.service';

@Injectable({
    providedIn: 'root'
})
export class AjaxInterceptorService extends BaseService {

    constructor() {
        super();
     }

    //progress-mask
    private showProgressSub = new BehaviorSubject<boolean>(true);
    showProgressMask = this.showProgressSub.asObservable();

    private isAdminSub = new BehaviorSubject<boolean>(true);
    isAdmin = this.isAdminSub.asObservable();

    //Call this from interceptor during any http activity.
    setProgressSMasktatus(status: boolean) {
        this.showProgressSub.next(status);
    }

    setIsAdmin(status: boolean) {
        this.isAdminSub.next(status);
    }
}